export const SkillKeys = [

    "Q", "W", "E", "R"
]
